<div *ngIf="showQualityInspect" class="qualityInspect">
    <div class="qualityInspect-container">
        <svg class="svg">
            <use xlink:href="#core-icon-simple-status-failed"></use>
        </svg>
        <div class="qualityInspect-content ml-8">
            <span id="qualityMsg">{{qualityInspectInfo}}</span>
            <n-help-link key="qualityInspect" class="helpLink" icon="core-icon-simple-help-icon"></n-help-link>
        </div>
    </div>
</div>
